// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"2985c719","453":"a4ff3c27","455":"b15ccbbc","977":"8ef280a4"}[chunkId] + ".chunk.js";
};